import React, { Fragment, useEffect, useState } from 'react';
import { ModalType, useFormikEntryFilters } from '../../../../utils';
import RefundsView from '../Views/RefundsView';
import { RefundsFilter } from '../../types/refunds-response';
import {
  useCancellationRefund,
  useFetchRefundById,
  useFetchRefundByIdItems,
  useFetchRefundRequests,
} from '../../../../hooks';
import { useRefundStates } from '../../../../share';
import RefundsCreateContainer from './RefundsCreateContainer';
import RefundsDetailContainer from './RefundsDetailContainer';
import { authAtom } from '../../../../state';
import { useAtom } from 'jotai';
import ModalConfirm from '../components/ModalConfirm';
import { useRefundAnnul } from '../../../../utils/validators/refund-request/refund-request-validator';
import { modalStateAtom } from '../../../../state/atoms';
import dayjs from 'dayjs';

const RefundsContainer: React.FC = () => {
  const { data: refundStates } = useRefundStates();
  const { mutateAsync, isPending: loadCreate } = useCancellationRefund();

  //manage state modal
  const [modalState, setModalState] = React.useState<{
    type: ModalType;
    id?: string;
  }>({ type: null, id: undefined });

  const [authData] = useAtom(authAtom);
  const [modalAtom, setModalAtom] = useAtom<boolean>(modalStateAtom);
  const [solicitudSelected, setSolicitudSelected] = useState();

  const [filter, setFilter] = React.useState<RefundsFilter>({
    requester_id: authData?.user.id,
  });
  const [isModalConfirm, setIsModalConfirm] = useState(false);
  const {
    data: refunds,
    isPending: loadList,
    refetch,
  } = useFetchRefundRequests(filter);

  const { data: refund, isPending: loadById } = useFetchRefundById(
    modalState.id
  );

  const { data: items, isLoading: loadingItems } = useFetchRefundByIdItems(
    modalState.id
  );

  const handleModalToggle = (type: ModalType | null, id?: string) => {
    setModalState({
      type: type,
      id: id,
    });
    setModalAtom(false);
  };

   const handleViewCreate = () => {
    setModalState({ type: 'create', id: undefined });
  };

  const handleViewDetail = (id: string) => {
    setModalState({ type: 'detail', id: id });
  };

  const handlePagination = (page: number) => {
    setFilter({
      page: page.toString(),
    });
  };

  const handleFilter = async (values: RefundsFilter) => {
    const createdAt = values.created_at
    ? dayjs(values.created_at).format("YYYY-MM-DD")
    : undefined;
    setFilter({
      ...values,
      created_at: createdAt,
      requester_id: authData?.user.id,
    });
  };

  const formik = useFormikEntryFilters({ onSubmit: handleFilter });
  const handleModalConfirm = (opc: boolean) => {
    formikCancel.resetForm();
    setIsModalConfirm(opc);
  };
  const handleSolicitudSelected = (id: any) => {
    setSolicitudSelected(id);
    handleModalConfirm(true);
  };

  const onSaveCancellation = async (data: any) => {
    const payload: any = {
      observations: data.observations,
      id: solicitudSelected,
    };
    try {
      await mutateAsync(payload);
      setFilter({
        ...filter,
        requester_id: authData?.user.id,
      });
      handleModalConfirm(false);
    } catch (error) {}
  };

  const onSaveCancellationValidate = () => {
    if (formikCancel.isValid) {
      formikCancel.handleSubmit();
    }
  };
  const formikCancel = useRefundAnnul({ onSubmit: onSaveCancellation });

  useEffect(() => {
    refetch();
  }, [filter]);

  return (
    <Fragment>
      <RefundsCreateContainer
        isOpen={modalState.type === 'create' || modalAtom}
        OnClose={() => handleModalToggle(null)}
        modalState={modalState}
        refetch={refetch}
      />

      <RefundsDetailContainer
        isOpen={modalState.type === 'detail'}
        OnClose={() => handleModalToggle(null)}
        dataApi={refund}
        isLoading={loadById}
        items={items}
        isLoadingItems={loadingItems}
      />

      <RefundsView
        isLoading={loadList}
        data={refunds}
        states={refundStates}
        formik={formik}
        onViewDetail={handleViewDetail}
        onViewCreate={handleViewCreate}
        onPagination={handlePagination}
        onResetFilters={() => {
          handleFilter({});
          formik.resetForm();
        }}
        handleModalConfirm={handleSolicitudSelected}
      />
      <ModalConfirm
        onSave={onSaveCancellationValidate}
        isShow={isModalConfirm}
        handleModalConfirm={handleModalConfirm}
        formik={formikCancel}
      />
    </Fragment>
  );
};

export default RefundsContainer;
